import { Link, Outlet } from 'react-router-dom';

import loginVector from '@dmp/assets/icons/login-vector.png';
import logoWhite from '@dmp/assets/icons/logo-white.svg';
import { ROUTE_PATHS } from '@dmp/constant';

export const AuthLayout = () => {
  return (
    <div className="h-full flex flex-col gap-[38px] py-[50px] px-[20px] md:px-[64px] bg-[#6D1799] overflow-y-auto">
      <Link to={ROUTE_PATHS.LANDING_PAGE}>
        <img src={logoWhite} alt="logo" className="h-[48px]" />
      </Link>
      <div className="flex-1 flex flex-col justify-center">
        <div className="md:px-[80px]">
          <div className="flex ">
            <div
              className="basis-1/2 md:basis-3/5 grow-0 shrink-0 flex items-center justify-center
              border border-white  rounded-tl-[40px] rounded-bl-[40px] p-[30px]"
            >
              <div>
                <img src={loginVector} alt="login-vector" />
                <div className="text-[#fff] text-[22px] font-bold text-center">AI Data Platform</div>
              </div>
            </div>
            <div className="basis-1/2 md:basis-2/5 grow-0 shrink-0 bg-white rounded-tr-[40px] rounded-br-[40px]">
              <Outlet />
            </div>
          </div>
        </div>
        <div className="text-center text-[#fff] mt-[50px]">
          <div>© {new Date().getFullYear()} Centific. All Rights Reserved </div>
          <ul className="flex gap-5 justify-center mt-1">
            <li>
              <a href={ROUTE_PATHS.PRIVACY_POLICY} target="_blank" className="underline">
                Privacy Policy
              </a>
            </li>
            <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
              <a href={ROUTE_PATHS.TERMS_OF_USE} target="_blank" className="underline">
                Terms & Conditions
              </a>
            </li>
            <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
              <a href={ROUTE_PATHS.COOKIE_POLICY} target="_blank" className="underline">
                Cookie Policy
              </a>
            </li>
            <li className="relative before:content-[''] before:w-[1px] before:h-full before:bg-[#d6d6d6] before:absolute before:top-0 before:left-[-10px]">
              <a href={ROUTE_PATHS.FAQ} target="_blank" className="underline">
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
